import Feature from '../../models/feature';
import { Collapse, FormGroup, MenuItem } from '@blueprintjs/core';
import { useState } from 'react';
import { Column, Row } from '../flex';
import { DateInput } from '@blueprintjs/datetime';
import {formatDate, formatDateTime, parseDate, parseDateTime} from '../../common';
import moment from 'moment';

export interface Props {
  feature: Feature
  onChange: (sinceDate: Date | null, tillDate: Date | null) => void
}

export default function EventEditor({ feature, onChange }: Props) {
  const [ isOpen, setIsOpen ]  = useState(false);
  const [ since, setSince ]  = useState<Date | null>(feature.properties.metadata && feature.properties.metadata.dateStart ? new Date(feature.properties.metadata.dateStart) : null);
  const [ till, setTill ]  = useState<Date | null>(feature.properties.metadata && feature.properties.metadata.dateEnd ? new Date(feature.properties.metadata.dateEnd) : null || null);

  const onSinceChange = (since: Date | null) => {
    setSince(since);
    onChange(since, till);
  }

  const onTillChange = (till: Date | null) => {
    setTill(till);
    onChange(since, till);
  }

  const label = <MenuItem
    text="Event Editor"
    icon={isOpen ? 'chevron-down' : 'chevron-right'}
    onClick={() => setIsOpen(!isOpen)}
  />

  return <Column flex={1} className="edit-block menu-block">
    <FormGroup label={label}>
      <Collapse isOpen={isOpen}>
        <div>
          <FormGroup
            label="Since"
            inline={true}>
            <DateInput
              formatDate={formatDateTime}
              parseDate={parseDateTime}
              value={since}
              onChange={onSinceChange}
              highlightCurrentDay={true}
              placeholder='Starts at'
              timePrecision="minute"
              closeOnSelection={false}
              inputProps={{ style: { width: '100%' } }}
            />
          </FormGroup>
          <FormGroup
            label="Till"
            inline={true}>
            <DateInput
              formatDate={formatDateTime}
              parseDate={parseDateTime}
              value={till}
              onChange={onTillChange}
              highlightCurrentDay={true}
              placeholder='Ends at'
              timePrecision="minute"
              closeOnSelection={false}
              inputProps={{ style: { width: '100%' } }}
            />
          </FormGroup>
        </div>
      </Collapse>
    </FormGroup>
  </Column>
}
